/**
 * Remove non-word chars.
 */
var removeNonWord = function removeNonWord(str) {
  return str.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, '');
};

export default removeNonWord;